import { useCallback, useState } from 'react';

/**
 * Returns which term is being shown.
 */
export const useTermsBeingShown = () => {
  const [termsBeingShown, setTermsBeingShown] = useState<RewardTerms | null>(null);

  const showTerms = useCallback((reward: RewardTerms) => {
    return () => {
      setTermsBeingShown(reward);
    };
  }, []);

  const hideTerms = useCallback(() => {
    setTermsBeingShown(null);
  }, []);

  return {
    termsBeingShown,
    showTerms,
    hideTerms,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type RewardTerms = {
  name: string;
  terms: string;
  expirationDate: string | null;
};
